<template>
  <links :items="components"></links>
</template>

<script>
import links from "moodleDir/procollege/lib/vue/link-list.vue";
export default {
  data() {
    return {
      components: [],
    };
  },
  components: {
    links,
  },
  watch: {
    $route() {
      this.updateComponents()
    }
  },
  created() {
    this.updateComponents()
  },
  methods: {
    updateComponents() {
      let path = this.$route.path

      if (path === "/") {
        this.components = Object.values(this.$model.modules)
        return
      }

      const findController = (controllers) => {
        for (let controllerName in controllers) {
          const c = controllers[controllerName]

          if (c.url === path) {
            let result = Object.fromEntries(
              Object.entries(c.modules).filter(([key, value]) => {
                return value.visible;
              })
            );

            return result
          }

          if (path.includes(c.url)) {
            return findController(c.modules)
          }
        }
      }

      this.components = Object.values(findController(this.$model.modules))
    }
  }
};
</script>
